'use client'

import React from 'react'
// import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
// import { segmentEventCommonPropFunc } from '@utils/segmentProperties'
import styles from './travelPass.module.scss'

export const TravePassBanner = () => {
  const handleClick = async () => {
    // const commonProps = await segmentEventCommonPropFunc({})

    const isMobile = window.matchMedia('(max-width: 768px)').matches
  const targetUrl = isMobile
    ? '/travel/domestic-pass/purchase/'
    : '/travel/domestic-pass/view/'

    // await trackEvent('tap_btn_airpass', {
    //   ...commonProps,
    //   type: 'banner strip',
    //   cta_text: 'Join the waitlist →',
    // })

    window.location.href = targetUrl
  }

  return (
    <div className={styles.component}>
      <div className={styles.promoBannerContainer}>
        <div className={styles.promoBannerLeft}>
          <div className={styles.promoBannerIcon}>
            <img
              src="https://acko-cms.ackoassets.com/b81002805bb2257a7e52e0b490cc4e5b89fa1973_d73a9d8757.webp"
              alt="Promo Icon"
            />
          </div>
          <div className={styles.promoBannerText}>
            <div className={styles.desktopText}>
              <p>
                <span>Domestic flight issues?</span>
                <br />
                Delays, cancellations or missed flights, <span>ACKO AirPass</span> instantly solves your domestic travel
                problems
              </p>
            </div>
            <div className={styles.mobileText}>
              <p>
                <strong>AirPass (for domestic travel)</strong>
                <br />
                Delays, cancellations or missed flights, AirPass makes it all right
              </p>
            </div>
            <div
              className={styles.promoBannerCTA}
              onClick={() => {
                void handleClick()
              }}>
              {' '}
              <div className={styles.promoBannerCTALabel}>
                <span>Just Launched</span>
              </div>
              <div className={styles.promoBannerCTAText}>Explore AirPass →</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
